import { useState, useMemo } from "react";

const allCities = [
  { name: "Allentown", route: "/allentown", tagline: "Lehigh Valley expedited passport services", highlights: ["Lehigh County coverage", "Serving Bethlehem, Easton, Whitehall"], badge: null, status: "live" },
  { name: "Altoona", route: "/altoona", tagline: "Blair County expedited passport processing", highlights: ["Blair County coverage", "Serving Hollidaysburg, Tyrone"], badge: null, status: "live" },
  { name: "Bethlehem", route: "/bethlehem", tagline: "Northampton County expedited passport services", highlights: ["Lehigh Valley coverage", "Serving Allentown, Easton"], badge: null, status: "live" },
  { name: "Bloomsburg", route: "/bloomsburg", tagline: "Columbia County expedited passport processing", highlights: ["Bloomsburg area coverage", "Serving Berwick, Danville"], badge: null, status: "live" },
  { name: "Chambersburg", route: "/chambersburg", tagline: "Franklin County expedited passport services", highlights: ["South Central PA coverage", "Serving Waynesboro, Shippensburg"], badge: null, status: "live" },
  { name: "Chester", route: "/chester", tagline: "Delaware County expedited passport processing", highlights: ["Philadelphia metro coverage", "Serving Upper Darby, Media"], badge: null, status: "live" },
  { name: "Easton", route: "/easton", tagline: "Northampton County expedited passport services", highlights: ["Lehigh Valley coverage", "Serving Bethlehem, Nazareth"], badge: null, status: "live" },
  { name: "Erie", route: "/erie", tagline: "Northwest Pennsylvania expedited passport hub", highlights: ["Erie County coverage", "Serving Millcreek, Harborcreek"], badge: null, status: "live" },
  { name: "Gettysburg", route: "/gettysburg", tagline: "Adams County expedited passport services", highlights: ["Historic Gettysburg area", "Serving Hanover, Littlestown"], badge: null, status: "live" },
  { name: "Harrisburg", route: "/harrisburg-pa", tagline: "Dauphin County expedited passport processing", highlights: ["State capital coverage", "Serving Hershey, Mechanicsburg, Camp Hill"], badge: null, status: "live" },
  { name: "Hazleton", route: "/hazleton", tagline: "Luzerne County expedited passport services", highlights: ["Hazleton area coverage", "Serving Wilkes-Barre, Pittston"], badge: null, status: "live" },
  { name: "Johnstown", route: "/johnstown", tagline: "Cambria County expedited passport processing", highlights: ["Johnstown area coverage", "Serving Westmont, Richland"], badge: null, status: "live" },
  { name: "King of Prussia", route: "/king-of-prussia", tagline: "Montgomery County expedited passport services", highlights: ["Philadelphia metro coverage", "Serving Norristown, Conshohocken"], badge: null, status: "live" },
  { name: "Lancaster", route: "/lancaster", tagline: "Lancaster County expedited passport services", highlights: ["Amish Country coverage", "Serving Lititz, Ephrata, Manheim"], badge: null, status: "live" },
  { name: "Lebanon", route: "/lebanon-pa", tagline: "Lebanon County expedited passport processing", highlights: ["Lebanon area coverage", "Serving Palmyra, Annville"], badge: null, status: "live" },
  { name: "Lehigh Valley", route: "/lehigh-valley", tagline: "Allentown-Bethlehem-Easton metro passport services", highlights: ["Three-city metro coverage", "Serving Northampton, Lehigh counties"], badge: null, status: "live" },
  { name: "Main Line", route: "/main-line", tagline: "Philadelphia suburbs expedited passport services", highlights: ["Ardmore, Bryn Mawr, Wayne area", "Serving Radnor, Haverford, Lower Merion"], badge: null, status: "live" },
  { name: "McKeesport", route: "/mckeesport", tagline: "Allegheny County expedited passport processing", highlights: ["Pittsburgh metro coverage", "Serving West Mifflin, Duquesne"], badge: null, status: "live" },
  { name: "Monroeville", route: "/monroeville", tagline: "Allegheny County expedited passport services", highlights: ["Pittsburgh metro coverage", "Serving Murrysville, Plum"], badge: null, status: "live" },
  { name: "Mount Pocono", route: "/mount-pocono", tagline: "Monroe County expedited passport services", highlights: ["Pocono Mountains coverage", "Serving Stroudsburg, East Stroudsburg"], badge: null, status: "live" },
  { name: "New Castle", route: "/new-castle", tagline: "Lawrence County expedited passport processing", highlights: ["New Castle area coverage", "Serving Ellwood City, Uniontown"], badge: null, status: "live" },
  { name: "Norristown", route: "/norristown", tagline: "Montgomery County expedited passport services", highlights: ["Philadelphia metro coverage", "Serving King of Prussia, Conshohocken"], badge: null, status: "live" },
  { name: "Philadelphia", route: "/philadelphia", tagline: "Southeast Pennsylvania's premier passport courier service", highlights: ["24-hour emergency service", "Serving Center City, Northeast, South Philly"], badge: "Most Popular", status: "live" },
  { name: "Pittsburgh", route: "/pittsburgh", tagline: "Western Pennsylvania expedited passport hub", highlights: ["Allegheny County coverage", "Serving Mt. Lebanon, Squirrel Hill, North Hills"], badge: "Most Popular", status: "live" },
  { name: "Pottstown", route: "/pottstown", tagline: "Montgomery County expedited passport processing", highlights: ["Western Montgomery coverage", "Serving Boyertown, Phoenixville"], badge: null, status: "live" },
  { name: "Reading", route: "/reading", tagline: "Berks County expedited passport services", highlights: ["Reading area coverage", "Serving Wyomissing, West Reading"], badge: null, status: "live" },
  { name: "Scranton", route: "/scranton", tagline: "Lackawanna County expedited passport processing", highlights: ["Northeast PA coverage", "Serving Wilkes-Barre, Dunmore, Clarks Summit"], badge: null, status: "live" },
  { name: "State College", route: "/state-college", tagline: "Centre County expedited passport services", highlights: ["Penn State area coverage", "Serving Bellefonte, Boalsburg"], badge: null, status: "live" },
  { name: "Upper Darby", route: "/upper-darby", tagline: "Delaware County expedited passport processing", highlights: ["Philadelphia metro coverage", "Serving Drexel Hill, Lansdowne"], badge: null, status: "live" },
  { name: "West Chester", route: "/west-chester", tagline: "Chester County expedited passport services", highlights: ["West Chester area coverage", "Serving Exton, Downingtown, Kennett Square"], badge: null, status: "live" },
  { name: "Wilkes-Barre", route: "/wilkes-barre", tagline: "Luzerne County expedited passport services", highlights: ["Wyoming Valley coverage", "Serving Kingston, Hazleton, Pittston"], badge: null, status: "live" },
  { name: "Williamsport", route: "/williamsport", tagline: "Lycoming County expedited passport processing", highlights: ["Williamsport area coverage", "Serving Montoursville, Muncy"], badge: null, status: "live" },
  { name: "York", route: "/york-pa", tagline: "York County expedited passport services", highlights: ["York area coverage", "Serving Hanover, Shrewsbury, Red Lion"], badge: null, status: "live" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function PennsylvaniaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Pennsylvania Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Pennsylvania Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Pennsylvania</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Pennsylvania locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}